import React, { useState, useEffect } from "react";
import { Layout, Typography } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { authenticationService, companyService } from "../../app/services";
import useWindowResizeListener from "../../helpers/useWindowResizeListener";
import ProfileForm from "./ProfileForm";
import SidebarMenu from "./SidebarMenu";
import PreferencesPage from "./PreferencesPage";
import TeamMembersPage from "./TeamMembersPage";
import CompanyServicesPage from "./CompanyServicesPage";
import WebsiteEditorPage from "./WebsiteEditorPage";
import ClientsPage from "./ClientsPage";
import { setProfile } from "../../app/services/user.slice"; 

const { Content } = Layout;
const { Title } = Typography;

const UserProfilePage = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [activeMenu, setActiveMenu] = useState("profile");
  const { width } = useWindowResizeListener();

  const dispatch = useDispatch();
  const profile = useSelector((state) => state.user.profile);

  // ✅ fetch profile from backend when app launches
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const profileData = await authenticationService.getUserByToken();
        dispatch(setProfile(profileData));

        if (
          profileData?.roles?.some(
            (role) => role.name === "COMPANYREQUESTVALIDATOR"
          )
        ) {
          await companyService.getPendingRequests();
        }
      } catch (error) {
        console.error("Failed to fetch profile or company requests", error);
      }
    };

    fetchUserProfile();
  }, [dispatch]);

  const handleMenuClick = (key) => setActiveMenu(key);

  const handleProfileUpdated = (newProfile) => {
    // ✅ update Redux state
    dispatch(setProfile(newProfile));
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <SidebarMenu
        collapsed={collapsed}
        onCollapse={() => setCollapsed(!collapsed)}
        activeKey={activeMenu}
        onMenuClick={handleMenuClick}
        profile={profile}
      />

      <Layout>
        <Content style={{ padding: "24px", background: "#fafafa" }}>
          {activeMenu === "profile" && profile && (
            <ProfileForm
              profile={profile}
              onProfileUpdated={handleProfileUpdated}
            />
          )}

          {/* Event Types section removed */}

          {activeMenu === "team-members" && profile?.type === "Pro" && (
            <TeamMembersPage company={profile?.username} />
          )}

          {activeMenu === "clients" && profile?.type === "Pro" && (
            <ClientsPage company={profile?.username} />
          )}

          {activeMenu === "company-services" && profile?.type === "Pro" && (
            <CompanyServicesPage
              profile={profile}
            />
          )}

          {activeMenu === "company-preferences" && profile?.type === "Pro" && (
            <PreferencesPage type="Pro" company={profile?.username} />
          )}

          {activeMenu === "company-websiteeditor" && profile?.type === "Pro" && (
            <WebsiteEditorPage type="Pro" companyUsername={profile?.username} />
          )}

        </Content>
      </Layout>
    </Layout>
  );
};

export { UserProfilePage };
